import api from "../api/flexapi";
import { showToast } from "./toastActions";

export const SET_ETHNICITY_BEGIN = "SET_ETHNICITY_BEGIN";
export const SET_ETHNICITY_SUCCESS = "SET_ETHNICITY_SUCCESS";
export const SET_ETHNICITY_ERROR = "SET_ETHNICITY_ERROR";

export const UPLOAD_IMAGE_BEGIN = "UPLOAD_IMAGE_BEGIN";
export const UPLOAD_IMAGE_SUCCESS = "UPLOAD_IMAGE_SUCCESS";
export const UPLOAD_IMAGE_ERROR = "UPLOAD_IMAGE_ERROR";

export const POST_AGE_FACE_BEGIN = "POST_AGE_FACE_BEGIN";
export const POST_AGE_FACE_SUCCESS = "POST_AGE_FACE_SUCCESS";
export const POST_AGE_FACE_ERROR = "POST_AGE_FACE_ERROR";

export const GET_FACE_IMAGE_BEGIN = "GET_FACE_IMAGE_BEGIN";
export const GET_FACE_IMAGE_SUCCESS = "GET_FACE_IMAGE_SUCCESS";
export const GET_FACE_IMAGE_ERROR = "GET_FACE_IMAGE_ERROR";

export const GET_AGING_STATUS_BEGIN = "GET_AGING_STATUS_BEGIN";
export const GET_AGING_STATUS_SUCCESS = "GET_AGING_STATUS_SUCCESS";
export const GET_AGING_STATUS_ERROR = "GET_AGING_STATUS_ERROR";

export const POST_RE_AGE_BEGIN = "POST_RE_AGE_BEGIN";
export const POST_RE_AGE_SUCCESS = "POST_RE_AGE_SUCCESS";
export const POST_RE_AGE_ERROR = "POST_RE_AGE_ERROR";

export const CONFIRM_WEBCAM_PHOTO_SUCCESS = "CONFIRM_WEBCAM_PHOTO_SUCCESS";
export const CONFIRM_WEBCAM_PHOTO_ERROR = "CONFIRM_WEBCAM_PHOTO_ERROR";

export const CONFIRM_PHOTO_UPLOAD_SUCCESS = "CONFIRM_PHOTO_UPLOAD_SUCCESS";
export const CONFIRM_PHOTO_UPLOAD_ERROR = "CONFIRM_PHOTO_UPLOAD_ERROR";

export const RESET_FACE_AGEING_PAGE = "RESET_FACE_AGEING_PAGE";
export const SET_AGE_FACE_PARAMS = "SET_AGE_FACE_PARAMS";

export const SUBMIT_PHOTO_BEGIN = "SUBMIT_PHOTO_BEGIN";
export const SUBMIT_PHOTO_ERROR = "SUBMIT_PHOTO_ERROR";

export function resetFaceAgeingPage() {
  return { type: RESET_FACE_AGEING_PAGE, payload: null };
}

export const setEthnicity = ethnicity => dispatch => {
  api
    .setEthnicity(ethnicity)
    .then(response => {
      dispatch({ type: SET_ETHNICITY_SUCCESS, payload: response.body });
    })
    .catch(err => {
      dispatch({
        type: SET_ETHNICITY_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const uploadImage = data => dispatch => {
  dispatch({ type: UPLOAD_IMAGE_BEGIN, payload: null });

  api
    .uploadFaceAgeingImage(data)
    .then(response => {
      dispatch({ type: UPLOAD_IMAGE_SUCCESS, payload: response.body });
    })
    .catch(err => {
      dispatch({
        type: UPLOAD_IMAGE_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const ageFace = () => (dispatch, getState) => {
  const { faceAgeing: { ageFaceParams } } = getState();
  api
    .postAgeFace(ageFaceParams)
    .then(response => {
      dispatch({ type: POST_AGE_FACE_SUCCESS, payload: response.body });
    })
    .catch(err => {
      dispatch({
        type: POST_AGE_FACE_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const getImage = data => dispatch => {
  dispatch({ type: GET_FACE_IMAGE_BEGIN, payload: null });

  api
    .getFaceAgeingImage(data)
    .then(response => {
      dispatch({ type: GET_FACE_IMAGE_SUCCESS, payload: response.body });
    })
    .catch(err => {
      dispatch({
        type: GET_FACE_IMAGE_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const reAge = data => dispatch => {
  api
    .postReAge(data)
    .then(response => {
      dispatch({ type: POST_RE_AGE_SUCCESS, payload: response.body });
    })
    .catch(err => {
      dispatch({
        type: POST_RE_AGE_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export function setAgeFaceParams(data) {
  return { type: SET_AGE_FACE_PARAMS, payload: data };
}

export function confirmCameraPhoto(filename, croppingRect, ethnicityId) {
  return dispatch => {
    dispatch({ type: SUBMIT_PHOTO_BEGIN, payload: null });

    return api
      .setEthnicity(ethnicityId)
      .catch(err => {
        dispatch({
          type: CONFIRM_WEBCAM_PHOTO_ERROR,
          payload: err.response ? err.response.body : err,
        });
      })
      .then(responses => {
        if (responses.body === "ok") {
          const ageFaceParams = { ...croppingRect, filename };
          api
            .postAgeFace(ageFaceParams)
            .then(resp => {
              if (resp && resp.body && resp.body.status == "success") {
                dispatch({ type: CONFIRM_WEBCAM_PHOTO_SUCCESS, payload: null });
              } else {
                dispatch({ type: SUBMIT_PHOTO_ERROR, payload: null });
                // eslint-disable-next-line no-secrets/no-secrets
                dispatch(showToast({ message: "uploadValidImageDescription" }));
              }
            })
            .catch(err => {
              dispatch({
                type: SUBMIT_PHOTO_ERROR,
                payload: err.response ? err.response.body : err,
              });
              // eslint-disable-next-line no-secrets/no-secrets
              dispatch(showToast({ message: "uploadValidImageDescription" }));
            });
        } else {
          dispatch({ type: CONFIRM_WEBCAM_PHOTO_ERROR, payload: null });
          // eslint-disable-next-line no-secrets/no-secrets
          dispatch(showToast({ message: "uploadValidImageDescription" }));
        }
      });
  };
}

export function confirmUploadPhoto(ethnicityId) {
  return (dispatch, getState) => {
    dispatch({ type: SUBMIT_PHOTO_BEGIN, payload: null });

    api
      .setEthnicity(ethnicityId)
      .then(response => {
        if (response.body == "ok") {
          const { faceAgeing: { ageFaceParams } } = getState();
          api.postAgeFace(ageFaceParams).then(resp => {
            if (resp && resp.body && resp.body.status == "success") {
              dispatch({ type: CONFIRM_PHOTO_UPLOAD_SUCCESS, payload: null });
            } else {
              dispatch({ type: SUBMIT_PHOTO_ERROR, payload: null });
              // eslint-disable-next-line no-secrets/no-secrets
              dispatch(showToast({ message: "uploadValidImageDescription" }));
            }
          });
        } else {
          dispatch({ type: CONFIRM_PHOTO_UPLOAD_ERROR, payload: null });
          // eslint-disable-next-line no-secrets/no-secrets
          dispatch(showToast({ message: "uploadValidImageDescription" }));
        }
      })
      .catch(err => {
        dispatch({
          type: CONFIRM_PHOTO_UPLOAD_ERROR,
          payload: err.response ? err.response.body : err,
        });
      });
  };
}

export const getAgingStatus = () => dispatch => {
  dispatch({ type: GET_AGING_STATUS_BEGIN, payload: null });

  api
    .getAgingStatus()
    .then(response => {
      dispatch({ type: GET_AGING_STATUS_SUCCESS, payload: response.body });
    })
    .catch(err => {
      dispatch({
        type: GET_AGING_STATUS_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};



// WEBPACK FOOTER //
// ./actions/faceAgeingActions.js